module.exports = __webpack_public_path__ + "static/media/adolescent-programs-active.854ec69b.svg";